/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_ValueInputs */

const cs_col_value = /** @type {(inputs: Col_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnota`)
};

const en_col_value = /** @type {(inputs: Col_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value`)
};

/**
* | output |
* | --- |
* | "Value" |
*
* @param {Col_ValueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_value = /** @type {((inputs?: Col_ValueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_ValueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_value(inputs)
	return cs_col_value(inputs)
});